import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { InvoiceDetailResponse } from './types';

/**
 * TanStack Query hook to fetch single invoice details from GET /api/v2/invoices/{public_token}/
 */
export function useInvoiceDetail(
  publicToken?: string,
  historyToken?: string
) {
  const isQueryable = Boolean(
    publicToken &&
    publicToken !== 'undefined' &&
    publicToken !== 'null' &&
    publicToken !== 'github-aug2026'
  );

  return useQuery<InvoiceDetailResponse>({
    queryKey: ['invoice', publicToken, historyToken],
    queryFn: async () => {
      if (!publicToken) {
        throw new Error('Public token is required to fetch invoice detail');
      }
      const params = historyToken ? { history_token: historyToken } : undefined;
      const response = await api.get<InvoiceDetailResponse>(
        `/v2/invoices/${publicToken}/`,
        { params }
      );
      return response.data;
    },
    enabled: isQueryable,
    retry: (failureCount, error: unknown) => {
      // Do not retry 403 Forbidden, 401, or 404 Not Found
      const status = (error as { response?: { status?: number } })?.response?.status;
      if (status === 403 || status === 404 || status === 401) {
        return false;
      }
      return failureCount < 1;
    },
    staleTime: 60_000,
  });
}
